export default __webpack_public_path__ + "static/media/duePayment.2650223e.svg";